<template>
  <div>
    <nav-bar />
    <v-container class="mt-10 pt-5">
      <!-- Page Header ########################################### -->
      <v-container>
        <v-row align="end">
          <v-col>
            <div class="page-title">
              <a @click.stop="goToInstitutionsManagement"
                ><v-icon class="mr-3">fal fa-arrow-left</v-icon></a
              >
              <h1>{{ moduleTitle }} de Instituição</h1>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-form ref="registerInstitutionForm" v-model="isInstitutionFormValid">
        <v-container>
          <!-- Card-1 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container class="d-flex align-center justify-space-between">
                <span class="list-labels">Dados básicos</span>
                <div class="d-flex flex-row align-center">
                  <span class="list-labels">Inativo</span>
                  <v-switch
                    class="ml-4"
                    inset
                    v-model="institution.entityViewModel.active"
                  ></v-switch>
                </div>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text class="py-0">
              <v-container py-0>
                <v-row>
                  <!-- avatar ###################################### -->
                  <v-col class="flex-shrink-0 flex-grow-0 pt-6">
                    <span class="d-flex align-center justify-center">
                      <v-avatar
                        size="220"
                        class="style-avatar flex-column justify-center"
                        tile
                      >
                        <div>
                          <v-icon
                            @click="onPickFile()"
                            size="35"
                            class="clickable flex-grow-0"
                            color="var(--gray-light)"
                            >fas fa-image</v-icon
                          >
                          <img
                            :src="selectedFileContent"
                            height="150"
                            @click="onPickFile()"
                          />
                          <input
                            type="file"
                            style="display: none"
                            ref="fileInput"
                            accept="image/*"
                            @change="onFilePicked"
                          />
                          <h6 class="tiny-label mt-2">LOGOTIPO</h6>
                        </div>
                      </v-avatar>
                    </span>
                  </v-col>
                  <!-- form dados básicos ###################################### -->
                  <v-col class="flex-grow-1">
                    <v-container fluid pa-0>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Nome da Instituição"
                            outlined
                            required
                            hide-details="auto"
                            v-model="institution.entityViewModel.name"
                            :rules="[validateInstitutionName]"
                            :disabled="registerInstitution"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-mask="['##.###.###/####-##']"
                            label="CNPJ"
                            outlined
                            hide-details="auto"
                            required
                            v-model="institution.entityViewModel.document"
                            :rules="[validateinstitutionDocument]"
                            :disabled="registerInstitution"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Razão Social"
                            outlined
                            hide-details="auto"
                            required
                            v-model="institution.entityViewModel.socialReason"
                            :rules="[validateInstitutionSocialReason]"
                            :disabled="registerInstitution"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-model="institution.councilIds"
                            :items="activeCouncilsList"
                            label="Conselhos Vinculados"
                            outlined
                            hide-details="auto"
                            multiple
                            chips
                            item-text="name"
                            item-value="id"
                          ></v-select>
                        </v-col>
                        <!-- <v-col cols="12" md="6">
                          <v-select
                            v-model="institution.fundId"
                            :items="fundsList"
                            required
                            label="Fundo"
                            item-text="name"
                            item-value="id"
                            outlined
                            hide-details="auto"
                          ></v-select>
                        </v-col> -->
                        <v-col cols="12" md="6">
                          <v-select
                            v-model="institution.emailFrequencyViewModel"
                            :items="emailFrequecncyPeriodList"
                            required
                            label="Periodicidade de Notificações e E-mails"
                            item-text="name"
                            outlined
                            return-object
                            hide-details="auto"
                            :rules="[validateEmailFrequencyOption]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <!-- Não remover o botão, usado para quebrar o form no responsivo ################################ -->
                      <v-row>
                        <v-col>
                          <v-btn
                            disabled
                            depressed
                            color="var(--feature)"
                            dark
                            rounded
                            large
                            class="px-12 op-0"
                            @click="showChangePassword = !showChangePassword"
                          >
                            <v-icon class="mr-3" small>fal fa-lock</v-icon
                            >Alterar Senha
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- form address ###################################### -->
        <!-- <AddressForm
          :registeredAddress="address"
          @newdata="handleData($event)"
        /> -->
        <AddressWithGoogleMapsImage
          v-model="institution.entityViewModel.addressViewModel"
          ref="address"
        />
        <!-- crud message dialog ###################################### -->
        <CrudMessageResponse
          :showMessage="showInstitutionCrudMessage"
          :message="institutionCrudMessage"
          @close="crudMessageResponseClose"
        />

        <!-- buttons float ###################################### -->
        <template>
          <v-footer fixed color="transparent" padless class="justify-center">
            <v-card elevation="6" class="pt-3 pb-4 px-4 footer-card">
              <v-btn
                @click="goToInstitutionsManagement()"
                color="secondary"
                rounded
                large
                depressed
                class="px-12 mr-1 white--text footer-border-left"
                >Voltar</v-btn
              >
              <v-btn
                color="secondary"
                rounded
                large
                depressed
                class="px-12 ml-1 footer-border-right"
                :disabled="!isInstitutionFormValid"
                @click="saveInstitution()"
                >Salvar</v-btn
              >
            </v-card>
          </v-footer>
        </template>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NavBar from "@/components/NavBar";
import Routes from "@/router/names.js";
import CommonHelper from "@/scripts/helpers/common.helper";
import GeneralService from "@/scripts/services/general.service";
import EntityService from "@/scripts/services/entity.service";
import CrudMessageResponse from "@/components/CrudMessageResponse";

export default {
  name: "institutionRegister",
  components: {
    NavBar,
    // AddressForm,
    CrudMessageResponse
  },
  data: () => ({
    generalService: new GeneralService(),
    entityService: new EntityService(),
    registerInstitution: false,

    //Form Information
    isInstitutionFormValid: false,

    // Institution Information
    emailFrequecncyPeriodList: [],
    activeCouncilsList: [],
    fundsList: [],
    institution: {
      councilIds: [],
      emailFrequencyViewModel: {
        name: "",
        id: 0
      },
      fundId: null,
      entityViewModel: {
        name: "",
        document: "",
        socialReason: "",
        active: true,
        addressViewModel: {
          postalCode: "",
          state: "",
          city: "",
          street: "",
          number: "",
          complement: "",
          neighborhood: "",
          googleAddress: ""
        }
      }
    },

    //Image information
    selectedFile: null,
    selectedFileContent: "",

    //Institution Data Control
    showInstitutionCrudMessage: false,
    institutionCrudMessage: "",
    institutionFromDatabase: {},
    canGotoInstitutionManagement: false,

    //Module Title
    moduleTitle: "Cadastro",

    address: {}
  }),
  computed: {
    ...mapGetters(["selectedInstitution"])
  },
  watch: {
    institutionDocument: function() {
      if (this.$route.params.institutionId == null) {
        this.checkIfInstitutionAlreadyExistsAndIfIsTrueReturn(
          this.institutionDocument
        );
      }
    }
  },
  created() {
    this.generalService.listAllEmailFrequencyPeriod().then(result => {
      this.emailFrequecncyPeriodList = result;
      this.institution.emailFrequencyViewModel = this.emailFrequecncyPeriodList.find(
        e => e.id === this.institution.emailFrequencyViewModel.id
      );
    });
    this.entityService.listAllActiveCouncils().then(result => {
      this.activeCouncilsList = result;
    });
    this.entityService.listAllActiveFunds().then(result => {
      this.fundsList = result;
    });

    if (
      this.$route.params.institutionId &&
      this.selectedInstitution &&
      this.selectedInstitution.id == this.$route.params.institutionId
    ) {
      this.moduleTitle = "Edição";

      this.loadInstitutionData(this.selectedInstitution);
    } else if (this.$route.params.institutionId) {
      this.getInstitutionByIdAndFillFields(this.$route.params.institutionId);
    } else {
      this.setSelectedInstitution(null);
    }
  },
  methods: {
    ...mapActions(["setSelectedInstitution"]),
    loadInstitutionData(selectedInstitution) {
      this.institution = { ...selectedInstitution };
      if (selectedInstitution.councilIds)
        this.institution.councilIds = [...selectedInstitution.councilIds];
      else this.institution.councilIds = [];
      this.institution.entityViewModel = {
        ...selectedInstitution.entityViewModel
      };
      this.institution.entityViewModel.addressViewModel = {
        ...selectedInstitution.entityViewModel.addressViewModel
      };
      if (
        this.emailFrequecncyPeriodList &&
        this.emailFrequecncyPeriodList.length > 0
      )
        this.institution.emailFrequencyViewModel = this.emailFrequecncyPeriodList.find(
          e => e.id === this.institution.emailFrequencyViewModel.id
        );
      if(this.institution.institutionLogo) {
        if (this.institution.institutionLogo.url)
          this.selectedFileContent = this.institution.institutionLogo.url;
        else
          this.selectedFileContent = `data:${this.institution.institutionLogo.contentType};base64, ${this.institution.institutionLogo.content}`;
      }
    },
    getInstitutionByIdAndFillFields(id) {
      this.entityService
        .getInstitutionById(id)
        .then(this.getInstitutionByIdCallBack)
        .catch(this.getInstitutionByIdCatch);
    },
    getInstitutionByIdCallBack(data) {
      this.setSelectedInstitution(data);
      this.institutionFromDatabase = data;
      this.loadInstitutionData(this.institutionFromDatabase);
    },
    saveInstitution() {
      this.showInstitutionCrudMessage = false;

      if (this.selectedInstitution != null) {
        this.institution.id = this.selectedInstitution.id;

        this.entityService
          .editInstitution(this.institution, this.selectedFile)
          .then(this.crudInstitutionCallBack)
          .catch(this.crudInstitutionCatch);
      } else {
        this.entityService
          .createInstitution(this.institution, this.selectedFile)
          .then(this.crudInstitutionCallBack)
          .catch(this.crudInstitutionCatch);
      }
    },
    crudInstitutionCallBack(response) {
      if(response.errorMessage) return;

      this.canGotoInstitutionManagement = true;
      this.showInstitutionCrudMessage = true;

      if (this.selectedInstitution != null) {
        this.institutionCrudMessage = "Instituição atualizada com sucesso!";
      } else {
        this.institutionCrudMessage = "Instituição criada com sucesso!";
      }
    },
    crudInstitutionCatch() {
      this.showInstitutionCrudMessage = true;

      if (this.selectedInstitution != null) {
        this.institutionCrudMessage =
          "Ops, desculpe, não foi possível atualizar, contate o suporte";
      } else {
        this.institutionCrudMessage =
          "Ops, desculpe, não foi possível cadastrar, contate o suporte";
      }
    },
    checkIfInstitutionAlreadyExistsAndIfIsTrueReturn() {
      if (this.institutionDocument != null) {
        this.entityService
          .checkIfInstitutionAlreadyExistsAndIfIsTrueReturn(
            this.institutionDocument
          )
          .then(this.getInstitutionByDocumentCallBack);
      }
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.selectedFile = files[0];
      let fileName = files[0].name;
      if (fileName.lastIndexOf(".") <= 0) {
        return alert("Por favor adicione um arquivo válido");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedFileContent = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
    },
    getInstitutionByDocumentCallBack(data) {
      if (data != null) {
        this.institutionFromDatabase = data;
        this.setSelectedInstitution(data);
        this.loadInstitutionData(this.institutionFromDatabase);
      }
    },
    validateInstitutionName() {
      if (!this.institution.entityViewModel.name)
        return "Preencha o nome da Instituição";
      return true;
    },
    validateinstitutionDocument() {
      if (!this.institution.entityViewModel.document)
        return "Preencha o documento";
      if (!CommonHelper.validateCNPJ(this.institution.entityViewModel.document))
        return "CNPJ inválido";
      return true;
    },
    validateInstitutionSocialReason() {
      if (!this.institution.entityViewModel.socialReason)
        return "Preencha a razão social da Instituição";
      return true;
    },
    validateEmailFrequencyOption() {
      if (
        this.institution.emailFrequencyViewModel != null &&
        this.institution.emailFrequencyViewModel.id > 0
      )
        return true;
      return "Escolha uma opção de envio de email";
    },
    goToInstitutionsManagement() {
      this.$router.push({ name: Routes.app.InstitutionManagement });
    },
    crudMessageResponseClose() {
      if (this.canGotoInstitutionManagement) {
        this.goToInstitutionsManagement();
      }
    }
  }
};
</script>